import { usePageTracking } from '@/hooks/analytics/use-page-tracking';

export function PageTracker(): null {
  usePageTracking();
  return null;
}

export default PageTracker;
